var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxBxQrScan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33366 6.33317H12.6828V3.1665H3.16699V12.6665H6.33366V6.33317ZM6.33366 25.3332H3.16699V34.8332H12.6828V31.6665H6.33366V25.3332ZM31.667 31.6665H25.3337V34.8332H34.8337V25.3332H31.667V31.6665ZM25.3337 6.33317H31.667V12.6665H34.8337V3.1665H25.3337V6.33317Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 17.4165H17.417V7.9165H7.91699V17.4165ZM11.0837 11.0832H14.2503V14.2498H11.0837V11.0832ZM7.91699 30.0832H17.417V20.5832H7.91699V30.0832ZM11.0837 23.7498H14.2503V26.9165H11.0837V23.7498ZM30.0837 7.9165H20.5837V17.4165H30.0837V7.9165ZM26.917 14.2498H23.7503V11.0832H26.917V14.2498ZM20.5995 20.5832H23.7662V23.7498H20.5995V20.5832ZM23.7662 23.7498H26.9328V26.9165H23.7662V23.7498ZM26.9328 26.9165H30.0995V30.0832H26.9328V26.9165ZM26.9328 20.5832H30.0995V23.7498H26.9328V20.5832Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxBxQrScan);
export default __webpack_public_path__ + "static/media/bx_bx-qr-scan.721f01175fa45693879bab7c075d984b.svg";
export { ForwardRef as ReactComponent };